<app-card class="header">
  <div>
    <app-ribbon type="idea" />
    <h1 i18n class="title">Wild Oats Mapping</h1>
    <p><b i18n>Prevent loss of yield and quality by knowing exactly where wild oats exist in your field</b></p>
    <p i18n>
      With a tool like this, you can take action against wild oats - preventing future losses in yield and quality.
      During harvest, your combine automatically detects wild oats and logs their exact location. After harvest, you
      will have a clear overview, ready for targeted weed control.
    </p>
  </div>
  <div>
    <div i18n class="subtitle">Have a look</div>
    <p i18n>Take a look at the scenario that illustrates how a tool for wild oats detection could work.</p>
    <p i18n>Have a look at the map, and consider how you would use a solution like this at your fields.</p>
    <p class="info-feedback">
      <span i18n>... and let us know what you think -</span>
      <app-link i18n target="_self" [href]="goToFeedback()">send your feedback</app-link>
    </p>
  </div>
</app-card>
<app-card>
  <app-card-title i18n-title title="Imagine how oats mapping could help you" />
  <app-steps [steps]="steps" />
</app-card>
<div class="more-info">
  <app-card class="detection">
    <app-card-title i18n-title title="Detection of wild oats during harvest" />
    <p i18n>Wild oats are detected in the grain tank, and their locations are automatically logged for later use.</p>
    <img src="images/WOM_detection.png" i18n-alt alt="Detection of wild oats" />
  </app-card>
  <app-card class="partners">
    <app-card-title i18n-title title="About the project" />
    <p i18n>
      AGCO and Google have joined forces to accelerate AI innovation in farming. By combining AGCO's agricultural
      expertise with Google Cloud's AI capabilities, the partnership transforms data from modern equipment into
      real-time insights - helping farmers make smarter, more profitable and sustainable decisions.
    </p>
    <p i18n>
      The first project from this collaboration is Wild Oats Mapping, which we're currently presenting to gather
      valuable feedback that will help refine and mature the concept.
    </p>
    <h3 i18n>Project partners</h3>
    <div class="logo-wrapper">
      <img class="google" src="images/WOM_google.png" i18n-alt alt="Google Cloud" />
      <img class="agco" src="images/WOM_agco.jpg" i18n-alt alt="AGCO" />
    </div>
  </app-card>
</div>
<div class="map">
  <app-card>
    <app-card-title i18n-title title="Wild oats map" />
    <p i18n>Location of wild oats during harvest</p>
    <app-map [height]="mapHeight" [features]="mapFeatures()" />
  </app-card>
</div>
<app-card id="feedback">
  <app-feedback-card feature="wild-oats-mapping" />
</app-card>
